export default "__VITE_ASSET__CTr9rB3R__"